export default __webpack_public_path__ + "static/media/lynnlu.ada8c03b.jpg";